import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

// 課題一覧取得用
type GetMinutesResponse = {
  minutes_list: Minute[];
}
// type Minute = {
//   issue_id: string;
//   issue: string;
//   analysis_status: string;
//   analysis_timestamp: number;
//   company_name: string;
//   source: string;
//   mql_companies_list: string;
// }
type Minute = {
  minute_id: string;
  minutes_original: string;
  analysis_status: string;
  analysis_timestamp: number;
  company_name: string;
  source: string;
  issue_list: Issues[];
  issue_count: number;
}
type Issues = {
  issue_id: string;
  extract_issue: string;
  core_issue: string;
  status: string;
}


// 分析実行用
type PostPredictInput = {
  content: string;
  company_name: string | null;
  source: string | null;
}
type PostPredictResponse = {
  status: number;
}

// 課題録削除用
type DeleteIssuesResponse = {
  status: number;
}

// 評価更新用
type PutFeedbackInput = {
  minute_id: string;
  issue_id: string;
  mql_id: string;
  idx: string;
  feedback: number;
  detail: string;
}
type PutFeedbackResponse = {
  issue_id: string;
  mql_id: string;
  idx: string;
  feedback: string;
  detail: number;
}

//見込み顧客取得用
export type GetMQLResponse = {
  mqls_list: Mqls_list[];
  next_key: string;
}
export type Mqls_list = {
  mql_id: string;
  mql_company_name: string;
  mql_industry: string;
  predict_score: number;
  number_of_persona: number;
}

// ペルソナ推定結果一覧取得用
type GetPersonasResponse = {
  personas_list: Personas[];
}
type Personas = {
  idx: number;
  persona: string;
  job: string;
  issue: string;
  needs: string;
  proposition: string;
  feedback_info:{ 
    feedback:number;
    detail:string;
  };
}

export const baseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API,
    prepareHeaders: async (headers, _) =>  {
      const queryParams = new URLSearchParams(window.location.search);
      const idToken = queryParams.get("idToken")
      const postMessageHandler = (e:any) => {
        if (e.data.type && "postIdToken" === e.data.type) {
          console.log("postMessageを受け取ったイベント情報：", e.data);
          localStorage.setItem('idToken', `${e.data.idToken}`);
        }
      };
      window.addEventListener("message", postMessageHandler);

      if(idToken){
        headers.set('Authorization', `${idToken}`)
        localStorage.setItem('idToken', `${idToken}`);
      } else {
        const idToken = localStorage.getItem('idToken');
        headers.set('Authorization', `${idToken}`)
      }
      return headers
    },
    mode: 'cors'
  }),
  endpoints: (builder) => ({
    getMinutes: builder.query<GetMinutesResponse, string>({
      query: (search) => {
        if (search.length !== 0) {
          return `issues?search=${encodeURIComponent(search)}`;
        }
        else {
          return `issues`;
        }
      }
    }),
    postPredict: builder.mutation<PostPredictResponse, PostPredictInput>({
      query(body) {
        return{
          url: `predict`,
          method: 'POST',
          body: body,
        }
      },
    }),
    deleteIssues: builder.mutation<DeleteIssuesResponse, string>({
      query(minute_id) {
        console.log('DELETE')
        return{
          url: `issues/${encodeURIComponent(minute_id)}`,
          method: 'DELETE'
        }
      }
    }),
    updateFeedback: builder.mutation<PutFeedbackResponse, PutFeedbackInput>({
      query(data) {
        const { minute_id, issue_id, mql_id, idx, ...body } = data
        return{
          url: `issues/${encodeURIComponent(minute_id)}/${encodeURIComponent(issue_id)}/${encodeURIComponent(mql_id)}/${encodeURIComponent(idx)}/feedback`,
          method: 'PUT',
          body,
        }
      }
    }),
    getMQL: builder.query<GetMQLResponse, { minute_id: string, issue_id: string}>({
      query: (data) => {
        const {minute_id, issue_id} = data
        return `issues/${encodeURIComponent(minute_id)}/${encodeURIComponent(issue_id)}/mqls`;
      }
    }),
    getPersonas: builder.query<GetPersonasResponse, { minute_id: string, issue_id: string, mql_id: string }>({
      query: (data) => {
        const {minute_id, issue_id, mql_id} = data
        return `issues/${encodeURIComponent(minute_id)}/${encodeURIComponent(issue_id)}/${encodeURIComponent(mql_id)}/personas`;
      }
    }),
  })
})

// use + endpointsで設定した名前 + QueryでHooksが作られる
export const { 
  useLazyGetMinutesQuery, 
  usePostPredictMutation, 
  useDeleteIssuesMutation,
  useUpdateFeedbackMutation,
  useLazyGetMQLQuery,
  useLazyGetPersonasQuery,
 } = baseApi
